/**
 * tabRoutes.js — the ONE list of "ordinary tab-bar landing routes": the four
 * screens TabBar.jsx renders as bottom-tab destinations. TabBar.jsx and
 * utils/whatsNew.js's mayShowOnPath both read this constant so the two can
 * never drift apart — one adds a fifth tab, the other's allowlist grows with
 * it, with no second edit to remember.
 *
 * ★★★ WHY THIS EXISTS (MAJOR, review of 184b4c43). WhatsNewSheet is mounted
 * once in MobileLayout, which wraps every route from /home to /case/emergency
 * to /settings/terms — not just the four tab destinations. MobileLayout does
 * NOT remount on an in-shell navigation (only its <Outlet> child changes), and
 * WhatsNewSheet computes its `pending` notes once, at that single mount, so a
 * full-viewport click-blocking backdrop stays up across every route until
 * dismissed. A patient whose FIRST authenticated screen is /case/emergency —
 * reached via a deep link that survives login (App.jsx's
 * orella_post_login_redirect) — would see that backdrop sitting on top of the
 * "Call 911" sheet. An ALLOWLIST, not a denylist: only these four routes are
 * safe landing spots for an informational sheet, and everything else —
 * including every /case/* flow, a dynamic /doctor/:id, every /settings/* page
 * — is refused by construction, not by enumerating what to exclude.
 */
export const TAB_ROUTES = ['/home', '/cases', '/visits', '/profile']
